/**
 * A face: the lines someone picked to bring a thing back, each with its heart
 * — picks are the heart everywhere in this product, and a face is what they
 * make. Words standing in where nothing was picked are the same lines without
 * one.
 */
export function Face({
  lines,
  picked = true,
  className,
}: {
  lines: string[];
  picked?: boolean;
  className?: string;
}) {
  if (lines.length === 0) return null;
  return (
    <div className={`doc-face${className ? ` ${className}` : ''}`}>
      {lines.map((line, i) => (
        <p key={i}>
          {picked && (
            <span className="doc-face-heart" aria-label="picked">
              <svg width="13" height="13" viewBox="0 0 12 12" aria-hidden="true">
                <path
                  d="M6 10.5S1.2 7.6 1.2 4.4A2.6 2.6 0 0 1 6 3a2.6 2.6 0 0 1 4.8 1.4c0 3.2-4.8 6.1-4.8 6.1z"
                  fill="currentColor"
                />
              </svg>
            </span>
          )}
          <span>{line}</span>
        </p>
      ))}
    </div>
  );
}
